import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { useSession } from "./useSession";

interface Selected {
  selectedId: string | null;
  select: (id: string) => void;
}

const Ctx = createContext<Selected | null>(null);

/** Boutique sélectionnée (pastilles « Mes boutiques » de la vue gérant). */
export function SelectedBoutiqueProvider({ children }: { children: ReactNode }) {
  const { me } = useSession();
  const [selectedId, setSelected] = useState<string | null>(me.boutiques[0]?.id ?? null);
  useEffect(() => {
    if (!selectedId || !me.boutiques.some((b) => b.id === selectedId)) setSelected(me.boutiques[0]?.id ?? null);
  }, [me.boutiques, selectedId]);
  const value = useMemo(() => ({ selectedId, select: setSelected }), [selectedId]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useSelectedBoutique(): Selected {
  const v = useContext(Ctx);
  if (!v) throw new Error("SelectedBoutiqueProvider manquant");
  return v;
}
